import React from "react";
import Screen from "./screen";
import { COLOR } from "../../../constants";

/**
 * LoadingBar component that displays a progress bar
 * @param {Object} props
 * @param {string} [props.color=COLOR.LOADING_BAR] - Color of the loading bar
 * @param {number} [props.loadingProgress=0] - Progress value (0-100)
 * @param {number} [props.height=4] - Height of the loading bar
 */
const LoadingBar = ({
  color = COLOR.LOADING_BAR,
  loadingProgress = 0,
  height = 4
}) => {
  return (
    <Screen
      progress={loadingProgress}
      color={color}
      height={height}
    />
  );
};

export default LoadingBar;
